import Lottie from 'react-lottie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HTTPSTATUS } from '../commonUtil/constants';
import CupAnimation from '../resources/cup.json';
import PluginAnimation from '../resources/plugin.json';
import { isLandscape } from '../commonUtil/responsiveUtil';

const ErrorPage = (props) => {
    const { t } = useTranslation();
    const { errorCode } = props;
    let animationData = null;
    let errorTitle = '';
    let errorDesc = '';
    if (errorCode === HTTPSTATUS.NOT_FOUNT) {
        animationData = CupAnimation;
        errorTitle = t('LIVE_SEND_VIEWER_WHOOPS');
        errorDesc = t('LIVE_SEND_VIEWER_PAGE_NOT_EXIST');
    } else {
        animationData = PluginAnimation;
        errorTitle = t('LIVE_SEND_VIEWER_BACK_MSG');
        errorDesc = t('LIVE_SEND_VIEWER_PAGE_UNAVAILABLE');
    }

    const lottieOptions = {
        loop: false,
        autoplay: true,
        animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        animationData && <div className="seismic-engagement-viewer-page-error">
            <div className={`seismic-engagement-viewer-page-error-anmation ${isLandscape() ? 'landscape' : ''}`}>
                <Lottie options={lottieOptions} />
            </div>
            <p className="seismic-engagement-viewer-page-error-title">{errorTitle}</p>
            <p className="seismic-engagement-viewer-page-error-description">{errorDesc}</p>
        </div>
    );
};

export default ErrorPage;
